import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import styled from 'styled-components';
import DefaultButton from 'components/button/DefaultButton';
import { Modal, Table } from 'antd';
import { commonSubScribeColumns } from 'consts/table';
import { useSetAtom } from 'jotai';
import modalInformationAtom from 'atom/modalInformationAtom';
import { useMutation } from '@tanstack/react-query';
import { reOrderRequest } from 'apis/PayApi';

interface ReSubScribeModalProps {
  open: boolean;
  registeredCard: { cardname: string; cardnumber: string };
  reSubScribeData: {
    subscribeid: string;
    programidx: number;
    subscribeType: number;
    price: number;
    currency: string;
    ticketName: string;
  };
  onCancel: () => void;
}

const ReSubScribeModal = ({
  onCancel,
  open,
  registeredCard,
  reSubScribeData
}: ReSubScribeModalProps) => {
  const { subscribeid, programidx, subscribeType, price, currency, ticketName } = reSubScribeData;

  const setModalInformation = useSetAtom(modalInformationAtom);

  const cardInforDataSource = [
    {
      userInfor: '카드',
      contents: registeredCard.cardname,
      key: 1
    },
    {
      userInfor: '번호',
      contents: registeredCard.cardnumber,
      key: 2
    }
  ];

  const membershipInforDataSource = [
    {
      userInfor: '멤버십',
      contents: <div>{ticketName}</div>,
      key: 1
    },
    {
      userInfor: '금액',
      contents: <div>{price.toLocaleString()}원</div>,
      key: 2
    }
  ];

  const requestReSubScribe = useMutation({
    mutationFn: (param: any) => reOrderRequest(param),

    onSuccess: (data: any) => {
      if (data.result === 'success') {
        setModalInformation({
          type: 'PAY_SUCCESS',
          handleClickRightBtn: () => {
            window.location.reload();
          }
        });
      } else {
        setModalInformation({
          type: 'PAY_CANCEL'
        });
      }
    }
  });

  const handleClickRequestReSubScribe = () => {
    const params = {
      secret: '#exbodymanualresubscrb@@',
      programidx: programidx // programidx 254
    };

    setModalInformation({
      type: 'MEMBERSHIP_SUBSCRIBE',
      handleClickRightBtn: () => {
        onCancel();
        requestReSubScribe.mutate(params);
      }
    });
  };

  return (
    <Modal open={open} onCancel={onCancel} footer={null} centered>
      <Wrapper>
        <Title>결제내역</Title>
        <div className="layout">
          <InforWrapper>
            <PayInfor>
              <div>
                <div>'결제 수단 관리'에 등록한 카드로 재결제를 시도합니다.</div>
              </div>
              <div>
                <div>카드 정보가 올바른지 다시 한 번 확인해주세요.</div>
              </div>
            </PayInfor>
          </InforWrapper>
          <SubTitle>카드정보</SubTitle>
          <Table
            columns={commonSubScribeColumns}
            showHeader={false}
            dataSource={cardInforDataSource}
            bordered
            pagination={false}
          />
          <SubTitle>멤버십정보</SubTitle>
          <Table
            columns={commonSubScribeColumns}
            showHeader={false}
            dataSource={membershipInforDataSource}
            bordered
            pagination={false}
          />
          <div className="infor">
            *재결제하신 날로부터 한 달 후가 다음 달 결제일입니다. ‘비즈멤버십 구독내역’ 상태 값의
            ‘다음결제일’을 확인해주세요.
          </div>
        </div>
        <DefaultButton onClick={handleClickRequestReSubScribe} type="primary" text="결제" />
      </Wrapper>
    </Modal>
  );
};

export default ReSubScribeModal;

const Title = styled.p`
  color: ${color.black2};
  text-align: center;
  ${font.h4_medium};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  p {
    display: flex;
    justify-content: center;
    button {
      width: 160px;
    }
  }

  div.layout {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  div.infor {
    color: ${color.gray600};
    ${font.caption1_regular};
  }

  .ant-table table {
    thead th,
    tbody {
      text-align: center;
    }

    thead th {
      padding: 8px 12px;
      color: ${color.gray600};
      ${font.caption1_regular};
    }

    tbody td {
      padding: 15px 12px;
      ${font.caption1_regular};

      &:first-of-type {
        background: ${color.gray100};
        text-align: center;
        color: ${color.gray600};
        ${font.caption1_regular};
      }

      &:last-of-type {
        color: ${color.black2};
        ${font.caption1_regular};
      }
    }
  }

  .ant-modal button.ant-modal-close {
    top: 16px;
    height: 16px;
  }
`;

const InforWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PayInfor = styled.div`
  display: flex;
  flex-direction: column;

  div {
    display: flex;
    ${font.body_regular};
    color: ${color.black2};
  }
`;

const SubTitle = styled.div`
  color: ${color.black2};
  ${font.body_regular};
  font-weight: 500;
`;
